/**
 * Shared student vs staff detection.
 * Staff (`user_type: "staff"`) always wins — student portal logic must not affect staff UI.
 */

export function isStaffUserType(userType) {
  return String(userType ?? "").trim().toLowerCase() === "staff";
}

export function isStudentUserType(userType) {
  return String(userType ?? "").trim().toLowerCase() === "student";
}

/** True when the session user should see the student leave portal only. */
export function isStudentSessionUser(user) {
  if (!user) return false;
  const userType = user.user_type ?? user.type;
  if (isStaffUserType(userType)) return false;
  if (isStudentUserType(userType)) return true;
  return user.role === "requester";
}

/** Map HR profile payload → student? (never overrides explicit staff type). */
export function isStudentFromHrProfile(profile, info = {}) {
  const userType = String(profile?.type ?? "").trim().toLowerCase();
  if (isStaffUserType(userType)) return false;
  if (isStudentUserType(userType)) return true;
  return Boolean(
    profile?.htno ||
      profile?.student_id ||
      info.program ||
      info.academic_status ||
      info.course_allotted,
  );
}
